import { inject, Injector } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { RedirectCommand, Router } from '@angular/router';
import type { OnyxHttpErrorResponse } from '@onyx/angular';
import { OnyxToastService } from '@onyx/angular';
import { catchError, map, of } from 'rxjs';
import { VALIDATION_ERROR_CODES } from '../../../../../common/constants/common/validation-error-codes';
import { ValidationHelper } from '../../../../../common/helpers/validation.helper';
import type { PointsOfInterestFormResolverData } from '../../points-of-interest.routes';
import { PointsOfInterestRoute } from '../enums/points-of-interest-route';
import { PointOfInterestFormHelper } from '../helpers/point-of-interest-form.helper';
import { PointsOfInterestService } from '../services/points-of-interest.service';

export const editPointOfInterestResolver: ResolveFn<
  PointsOfInterestFormResolverData
> = (route: ActivatedRouteSnapshot) => {
  const pointsOfInterestService = inject(PointsOfInterestService);
  const toastService = inject(OnyxToastService);
  const injector = inject(Injector);
  const router = inject(Router);

  const uuid = route.paramMap.get('uuid')!;

  return pointsOfInterestService.getPointOfInterest(uuid).pipe(
    map((dto) => ({
      form: PointOfInterestFormHelper.fromDto(dto),
      initial: PointOfInterestFormHelper.fromDto(dto),
    })),
    catchError((response: OnyxHttpErrorResponse) => {
      if (VALIDATION_ERROR_CODES.includes(response.status)) {
        toastService.showError({
          message: 'pointsOfInterest.toasts.pointNotFound',
          keepOnNavigation: true,
        });
        response.handled = true;
      } else {
        ValidationHelper.handleUnexpectedResponse(response, injector, {
          keepOnNavigation: true,
        });
      }

      const urlTree = router.parseUrl(
        PointsOfInterestRoute.POINTS_OF_INTEREST_LIST,
      );
      return of(new RedirectCommand(urlTree, { replaceUrl: true }));
    }),
  );
};
